import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Chart, registerables, Plugin } from 'chart.js';
import * as moment from 'moment';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { TootipService } from '../../graph/tooltip/tootip.service';
import * as _ from 'lodash'
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';

Chart.register(...registerables);

@Component({
  selector: 'app-score-line-chart',
  templateUrl: './score-line-chart.component.html',
  styleUrls: ['./score-line-chart.component.scss'],
  imports: [NgStyle, NgIf, NgFor, NgClass]
})

export class ScoreLineChartComponent implements OnInit {
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  private chartInstance: Chart | any;
  @Input() elementId: string = "score-line-chart"
  @Output() onGraphDataPointClick: any = new EventEmitter<any>();
  @Input('chartPlugins')
  set chartPlugins(value) {
    this.chartType = value?.chartType;
    this.lineColor = value?.lineColor;
    this.gradientStartColor = value?.gradientStartColor;
    this.gradientEndColor = value?.gradientEndColor;
    this.borderWidth = value?.borderWidth;
    this.pointBorderWidth = value?.pointBorderWidth;
    this.pointRadius = value?.pointRadius;
    this.pointBorderColor = value?.pointBorderColor;
    if (value?.useCustomMinMax == true) {
      this.min = value?.min;
      this.max = value?.max;
      this.stepSize = value?.stepSize;
    } else {
      if (this.data && this.data.length >= 1) {
        this.max = Math.max(...this.data);
        this.min = Math.min(...this.data);
      } else {
        this.min = value?.min;
        this.max = value?.max;
      }
      if (value?.min <= 0 && value?.max) {
        this.minY = value?.min;
        this.maxY = value?.max;
      }

      if (this.minY != -100 && this.maxY > 0) {
        this.min = this.minY;
        this.max = this.maxY;
      }

      if (this.maxY == 5 && this.minY == -5) {
        this.stepSize = 1;
      }
    }

  }

  @Input('chartData')
  set chartData(value) {
    this.labels = value?.labels;
    this.data = value?.data;
    this.xText = value?.xText;
    this.yText = value?.yText;
    this.yTextDisplayName = value?.yTextDisplayName;
    this.responses = value?.responses || [];
    this.showPercentage = !!value?.showPercentage;
    // if (this.data && this.data.length == 1) {
    //   this.gradientStartColor = '#fff';
    //   this.gradientEndColor = '#fff';
    // }
    let filteredData = _.filter(this.data,
      function (num) {
        return num != "N/A";
      }
    );
    if (filteredData && filteredData.length) {
      let maxVal = Math.max(...filteredData);
      let minVal = Math.min(...filteredData);
      if (minVal == 100 && maxVal == 100) {
        this.max = 100;
        this.min = 90;
      }
      if (minVal == -100 && maxVal == -100) {
        this.min = -100;
        this.max = -90;
      }
      if (minVal != maxVal && minVal >= 0 && maxVal <= 100 && value.yTextDisplayName == "Response rate (%)") {
        this.max = 100;
        this.min = 0;
      }
    }

    // let filteredData = _.filter(this.data,
    //   function (num) {
    //       return num != "N/A";
    //   }
    // );

    // if(filteredData && filteredData.length >= 1) {
    //   this.max = Math.max(...filteredData);
    //   this.min = Math.min(...filteredData);
    // } 

    // if (this.minY <= 0) {
    //   if (this.minY == -100) {
    //     this.stepSize = '';
    //     if (this.min > -90 && this.min < 0) {
    //       // convert the negetive to positive
    //       let minimumNumber = Math.abs(this.min)
    //       // find the nearest 10's number ex: for 72 it's convert to 80
    //       minimumNumber = Math.ceil((minimumNumber + 1) / 10) * 10;
    //       // // convert the positive to negetive
    //       this.min = -minimumNumber;
    //     } else {
    //       this.min = this.minY;
    //     }
    //   } else {
    //     this.min = this.minY;
    //   }
    // }

    // if (this.maxY >= 0) {
    //   if (this.maxY == 100) {
    //     if (this.max < 90) {
    //       this.max = Math.ceil((this.max + 1) / 10) * 10;
    //     } else {
    //       this.max = this.maxY;
    //     }
    //   } else {
    //     this.max = this.maxY;
    //   }
    // }

    // if (this.maxY == 5 && this.minY == -5) {
    //   this.stepSize = 1;
    // }
    // If chart instance already exists, destroy it to force redraw with new scale
    if (this.chartInstance) {
      this.destroyChart();
    }
    this.showChart();
  }

  lineColor: string = '';
  gradientStartColor: string = '';
  gradientEndColor: string = '';
  borderWidth: number = 0;
  pointBorderWidth: number = 0;
  pointRadius: number = 0;
  pointBorderColor: string = '';
  yText: string = '';
  yTextDisplayName: string = '';
  min: number = -100;
  max: number = 100;
  minY: number = 0;
  maxY: number = 0;
  stepSize: any = null;
  labels: any = [];
  data: any = [];
  xText: string = '';
  tooltipTitle = '';
  tooltipValue: any[] = [];

  tooltipHeading: string = '';
  tooltipCount: any = '';
  tooltipResponse: any = '';
  responses: any[] = [];

  event: any = {};
  previousTime: any = '';
  tooltipX: any = '';
  tooltipY: any = '';
  tooltipVisible: any = '';
  tooltipData: any = [];

  chartType = '';
  showPercentage = false;

  constructor(private helpersService: HelpersService, public _tootipService: TootipService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.showChart();
  }

  private showChart(): void {
    let self = this;
    // let YTEXT = this.yText;
    const YTEXT = (this.yTextDisplayName && this.yTextDisplayName != '') ? this.yTextDisplayName : this.yText;
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    // const tooltipElement = document.getElementById(this.elementId + 'tooltip') as HTMLDivElement;
    // const tooltipContent = document.getElementById(this.elementId + 'tooltip-content') as HTMLParagraphElement;
    // this.cdr.detectChanges();
    if (ctx) {
      this.destroyChart();
      const indicatorLinesPlugin: Plugin = {
        id: 'indicatorLines',
        beforeDraw: (chart) => {
          const chartArea = chart.chartArea;
          const dataset = chart.data.datasets[0];
          const meta = chart.getDatasetMeta(0);
          const yScale = chart.scales['y'];
          ctx.save();
          ctx.fillStyle = '#ffffff';
          const gradient = ctx.createLinearGradient(0, 0, 0, chartArea.bottom);
          // Add to remove gradien when single data will exist. 
          if (this.labels?.length > 1) {
            gradient.addColorStop(0, this.gradientStartColor);
            gradient.addColorStop(1, this.gradientEndColor);
            ctx.fillStyle = gradient;
          }

          ctx.beginPath();
          ctx.moveTo(chartArea.left, chartArea.bottom);
          for (let i = 0; i < dataset.data.length; i++) {
            const x = meta.data[i].x;
            const y = meta.data[i].y;
            ctx.lineTo(x, y);
          }
          ctx.lineTo(meta.data[meta.data.length - 1]?.x, chartArea.bottom);
          ctx.closePath();
          ctx.fill();
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 5;
          ctx.shadowBlur = 10;
          ctx.shadowColor = this.chartType == 'mutliSelect' ? '' : 'rgba(0, 0, 0, 0.6)';
          ctx.lineWidth = 2;
          ctx.strokeStyle = this.lineColor;
          ctx.beginPath();
          for (let i = 0; i < dataset.data.length; i++) {
            const x = meta.data[i].x;
            const y = meta.data[i].y;
            if (i === 0) {
              ctx.moveTo(x, y);
            } else {
              ctx.lineTo(x, y);
            }
          }
          ctx.stroke();
          ctx.restore();
        }
      };

      let dataSet: any = [];
      if(this.chartType == 'mutliSelect') {
        dataSet = [];
        this.data.forEach(item => {
          dataSet.push({
            data: item.data,
            borderColor: item.backgroundColor,
            borderWidth: 2,
            pointBorderWidth: 2,
            pointRadius: 6,
            pointBorderColor: item.backgroundColor,
            pointBackgroundColor: item.backgroundColor
          })
        })
      } else {
        dataSet = [
          {
            data: this.data,
            borderColor: this.lineColor,
            borderWidth: this.borderWidth,
            pointBorderWidth: this.pointBorderWidth,
            pointRadius: this.pointRadius,
            pointBorderColor: this.pointBorderColor,
            pointBackgroundColor: this.lineColor
          },
        ]
      }

      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: dataSet,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              enabled: false, // Disable the default tooltip,
              position: "nearest",
              // external: function (context) {

              //   const data = self._tootipService.tooltipHandler(context, {
              //     "dateFormats": {
              //       "Hourly": "hh:mm A",
              //       "Daily": "DD MMM 'YY",
              //       "Weekly": "DD MMM 'YY",
              //       "Monthly": "MMM 'YY",
              //       "Quarterly": "MMM 'YY",
              //       "Yearly": "YYYY"
              //     },
              //     "trendType": "Daily",
              //     "tooltipId": self.elementId,
              //     "tooltipFields": [],
              //     "tooltipData": []
              //   });

              //   const tooltipModel = context.tooltip;
              //   self.tooltipTitle = tooltipModel.dataPoints[0]?.label || '';
              //   self.tooltipValue = [{
              //     'order': 1,
              //     'label': YTEXT || '',
              //     'value': tooltipModel.dataPoints[0]?.raw.toString() || ''
              //   }];
              // },
              backgroundColor: '#ffffff',
              titleColor: '#000000',
              bodyColor: '#000000',
              displayColors: false,
              caretSize: 0,
              caretPadding: 20,
              xPadding: 20,
              yPadding: 20,
              intersect: false,
              bodyFont: {
                size: 14,
                fontFamily: 'Lato',
              },
              titleFont: {
                size: 13,
                weight: 'bold',
                fontFamily: 'Lato',
              },
              callbacks: {
                label: function (tooltipItem) {
                  return `${YTEXT}                    ${tooltipItem.raw}`;
                },
                title: function (tooltipItem) {
                  return `${tooltipItem[0].label}`;
                }
              },
            },
            legend: {
              display: false,
            }
          },
          scales: {
            x: {
              // border: {
              //   display: false
              // },
              offset: (this.labels?.length == 1) ? true : false, // Add to align single data to center. 
              title: {
                display: true,
                padding: {
                  top: 12
                },
                font: {
                  size: 14,
                  family: 'Lato',
                },
                // color: 'black',
                text: this.xText,
              },
              ticks: {
                maxRotation: 90,
                minRotation: 90,
                font: {
                  size: 13,
                  family: 'Asap'
                }
              },
            },
            y: {
              // offset: true,
              // border: {
              //   display: false
              // },
              title: {
                display: true,
                font: {
                  size: 14,
                  family: 'Asap',
                },
                text: this.yText,
              },
              ticks: {
                font: {
                  size: 13,
                  family: 'Asap'
                },
                precision: 0,
                stepSize: this.showPercentage ? 20 : this.stepSize,
                callback: (value: string | number) => {
                  if (this.showPercentage) {
                    return `${value}%`;
                  }
                  return value;
                }
              },
              min: this.showPercentage ? 0 : (this.chartType == 'mutliSelect' ? undefined : this.min),
              max: this.showPercentage ? 100 : (this.chartType == 'mutliSelect' ? undefined : this.max),
            },
          },
          onHover: (event, elements) => {
            if (elements.length) {
              this.chartCanvas.nativeElement.style.cursor = 'pointer';
              if (this.labels && this.labels.length > 0) {
                if (this.labels[0].includes('am') || this.labels[0].includes('pm') || this.labels[0].includes('AM') || this.labels[0].includes('PM')) {
                  this.chartCanvas.nativeElement.style.cursor = 'default';
                } else {
                  this.chartCanvas.nativeElement.style.cursor = 'pointer';
                }
              }
            } else {
              this.chartCanvas.nativeElement.style.cursor = 'default';
            }
          },
          onClick: (event, elements) => {
            if (elements && elements.length > 0) {
              const datasetIndex = elements[0]?.index;
              this.onGraphDataPointClick.emit(this.labels[datasetIndex]);
            }
          }
        } as any,
        plugins: [indicatorLinesPlugin]
      });
      this.chartInstance.canvas.addEventListener('mousemove', (event) => {
        const chartArea = this.chartInstance.chartArea;
        const mouseX = event.offsetX;
        const mouseY = event.offsetY;
        if (mouseX >= chartArea.left && mouseX <= chartArea.right && mouseY >= chartArea.top && mouseY <= chartArea.bottom) {
          const nearestIndex = Math.floor((mouseX - chartArea.left) / (chartArea.right - chartArea.left) * this.labels.length);
          if (nearestIndex >= 0 && nearestIndex < this.labels.length) {
            const obj = {
              index: nearestIndex,
              time: new Date().getTime()
            };
            this.event = obj;
            this.tooltipVisible = 'block';
          }
        } else {
          this.tooltipVisible = 'none';
        }
      });
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    const chartContainer = document.querySelector('.chart-container') as HTMLElement;
    const rect = chartContainer.getBoundingClientRect();
    if (((rect.right - rect.left) / 2) > event.offsetX) {
      this.tooltipX = event.offsetX + 15;
    } else {
      this.tooltipX = event.offsetX - 215;
    }
    this.tooltipY = event.offsetY + 10;
    if (this.previousTime !== this.event?.time && this.event?.time) {
      this.previousTime = this.event?.time;
      this.tooltipVisible = 'block';
    } else {
      this.tooltipVisible = 'none';
    }
    this.tooltipHeading = `${this.labels[this.event.index]}`;
    this.tooltipResponse = this.responses?.[this.event.index];
    if(this.chartType == 'mutliSelect') {
      this.tooltipData = [];
      this.data.forEach(dataPoint => {
        const count = dataPoint?.data[this.event.index];
        this.tooltipData.push({
          label: dataPoint?.label,
          count: this.showPercentage ? `${count}%` : count
        })
        // this.tooltipData[0].count = this.tooltipData[0].count + (dataPoint?.data[this.event.index] || 0)
      })
    } else {
      this.tooltipCount = this.data[this.event?.index];
    }
  }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }
}